import Typography from '@mui/material/Typography';
import { TableTooltip } from 'common/components/Tooltip/TableTooltip';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import {
  CellLayout,
  CellLayoutRow,
  CellLayoutSecondaryTypography,
  CellLayoutPrimaryTypography,
} from './CellLayout';
import { StickyCopyExtension } from 'src/common/StickyCopyExtension/StickyCopyExtension';
import React from 'react';

export const TypographyStyled = styled(Typography, { name: 'TextCellTypography' })({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}) as typeof Typography;

export const TextCell = React.memo(({ value, subValue, isValueLoading }: any) => {
  return (
    <CellLayout>
      <CellLayoutRow>
        {isValueLoading ? (
          <Skeleton height={18} data-testid="text-cell-skeleton" />
        ) : (
          <StickyCopyExtension value={value || ''}>
            <TableTooltip value={value || ''}>
              <CellLayoutPrimaryTypography>{value || '-'}</CellLayoutPrimaryTypography>
            </TableTooltip>
          </StickyCopyExtension>
        )}
      </CellLayoutRow>

      {subValue !== undefined && (
        <CellLayoutRow>
          <StickyCopyExtension value={subValue || ''}>
            <TableTooltip value={subValue || ''}>
              <CellLayoutSecondaryTypography>{subValue || '-'}</CellLayoutSecondaryTypography>
            </TableTooltip>
          </StickyCopyExtension>
        </CellLayoutRow>
      )}
    </CellLayout>
  );
});
